import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import Request from '../util/fetch';
import Toast from "../component/message/toast";

export const dataCenterType = 'datacenter';

makeActionType(dataCenterType, ['generalInfoSuccess', 'earningListFail']);
export const requestGeneralInfoSuccess = makeActionCreator(getActionType(dataCenterType, 'generalInfoSuccess'));
export const requestGeneralInfoFail = makeActionCreator(getActionType(dataCenterType, 'earningListFail'));


/**
 * 数据中心 视频数据  粉丝数据 的基本信息
 * @param {*} data
 */
export const requestDataCenterGeneralInfo = (data) => (dispatch) => {
    return Request.fetch({
        url: 'api/cloudvideo/creator/general/info/get'
    }).then(result => {
        if (result.code == 200) {
            return dispatch(requestGeneralInfoSuccess(result.data));
        }
        return dispatch(requestGeneralInfoFail());

    }).catch(error => {
        let rerr = Request.resolveError(error);
        dispatch(requestGeneralInfoFail());
        Toast({
            type: 'error',
            text: rerr.msg || '请求失败，请重试'
        });
    })

}


// WEBPACK FOOTER //
// ./client/action/datacenter.js